// Only two real Lincoln Invoice.STATUS_CHOICES values exist — an invoice
// stays Approved_Auto/Approved_Manual for life. Whether it's been sent is
// derived from dispatched_at being populated, not a third status value.
// Pre-dispatch, both statuses just show as plain "Approved" (see
// statusLabel() in ApprovedDispatchedInvoicesTable.vue) — the Draft table
// only offers one Approve action now, always dispatch_mode 'auto', so the
// Auto/Manual distinction stops being meaningful until it's actually sent.
// Once dispatched, Auto vs Manual still matters (how it was sent), so that
// distinction is kept here — single source of truth for both the display
// label and the status filter dropdown below, so the two can't drift.
export const APPROVED_LABEL = 'Approved'
export const DISPATCHED_STATUS_LABELS = {
  Approved_Auto: 'Dispatched (Auto)',
  Approved_Manual: 'Dispatched (Manual)',
}

// Shown instead of the Approved/Dispatched label whenever
// Invoice.changed_after_approve is true — takes precedence over both maps
// above (see statusLabel() in ApprovedDispatchedInvoicesTable.vue).
export const CHANGED_AFTER_APPROVE_LABEL = 'Draft (Changed after Approval)'

// One combined Draft table for both Market and LIMOSS (LIQ-2170). Some
// columns only apply to one billing type — TPA/Address/FileVine are
// Market-only (a LIMOSS draft has no TPA), Syndicate Number is LIMOSS-only
// (Market groups never split by syndicate) — and render "—" for the other.
// LIMOSS "periods" are quarterly, Market ones monthly.
export const DRAFT_BILLING_TYPE_OPTIONS = [
  { text: 'Both', value: 'Both' },
  { text: 'Market', value: 'Market' },
  { text: 'LIMOSS', value: 'LIMOSS' },
]

// Columns that only mean something for one billing type. With the Draft
// table's toggle on Market or LIMOSS, the other type's columns are hidden;
// on Both, every column shows.
const MARKET_ONLY_DRAFT_COLUMNS = ['tpa', 'tpa_address', 'filevine_id']
const LIMOSS_ONLY_DRAFT_COLUMNS = ['syndicate_number']

export function getGenerateInvoicesTableColumns(billingType = 'Both') {
  const hidden = {
    Market: LIMOSS_ONLY_DRAFT_COLUMNS,
    LIMOSS: MARKET_ONLY_DRAFT_COLUMNS,
  }[billingType] || []
  return [
    { key: 'invoice_ref', label: 'Invoice no.', sortable: true, searchable: true },
    { key: 'billing_type', label: 'Billing Type', sortable: true, searchable: true },
    { key: 'tpa', label: 'TPA', sortable: true, searchable: true },
    { key: 'underwriter', label: 'Underwriter', sortable: true, searchable: true },
    // LIMOSS only - a LIMOSS draft is one syndicate's share; Market shows "—".
    { key: 'syndicate_number', label: 'Syndicate Number', sortable: true, searchable: true },
    { key: 'currency_type', label: 'CCY', sortable: true, searchable: true },
    { key: 'current_bdx_count', label: 'BDX # this period', sortable: true, searchable: true },
    { key: 'previous_bdx_count', label: 'BDX # last period', sortable: true, searchable: true },
    { key: 'bdx_variance', label: 'Count variance', sortable: true, searchable: true },
    { key: 'amount_variance', label: 'Amount variance', sortable: true, searchable: true },
    { key: 'current_amount', label: 'Amount', sortable: true, searchable: true },
    { key: 'billing_contact', label: 'Billing contact', sortable: true, searchable: true },
    { key: 'tpa_address', label: 'Address', sortable: true, searchable: true },
    { key: 'filevine_id', label: 'FileVine Project Email', sortable: true, searchable: true }
  ].filter((column) => !hidden.includes(column.key))
}

export function getApprovedDispatchedTableColumns() {
  return [
    { key: 'invoice_ref', label: 'Invoice no.', sortable: true, searchable: true },
    { key: 'billing_type', label: 'Billing Type', sortable: true, searchable: true },
    { key: 'tpa', label: 'TPA', sortable: true, searchable: true },
    { key: 'underwriter', label: 'Underwriter', sortable: true, searchable: true },
    { key: 'currency_type', label: 'CCY', sortable: true, searchable: true },
    { key: 'bdx_count', label: 'BDX count', sortable: true, searchable: true },
    { key: 'amount', label: 'Amount', sortable: true, searchable: true },
    { key: 'billing_contact', label: 'Billing contact', sortable: true, searchable: true },
    { key: 'tpa_address', label: 'Address', sortable: true, searchable: true },
    { key: 'filevine_id', label: 'FileVine Project Email', sortable: true, searchable: true },
    {
      key: 'status', label: 'Status', sortable: true, searchable: true,
      options: [
        { text: APPROVED_LABEL, value: APPROVED_LABEL },
        { text: DISPATCHED_STATUS_LABELS.Approved_Auto, value: DISPATCHED_STATUS_LABELS.Approved_Auto },
        { text: DISPATCHED_STATUS_LABELS.Approved_Manual, value: DISPATCHED_STATUS_LABELS.Approved_Manual },
        { text: CHANGED_AFTER_APPROVE_LABEL, value: CHANGED_AFTER_APPROVE_LABEL },
      ],
    },
    { key: 'dispatched_at', label: 'Dispatched on', sortable: true, searchable: true, datePicker: { range: true } },
  ]
}
